import axios from "axios";

var http = axios.create({
    baseURL: process.env.API_BASE_URL + "itembank",
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token")
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    }
                )
                .then(function (response) {
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        })
                    );

                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        })
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    }
);

function getConfig() {
    return {
        headers: {
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function getVideoDetail(id, callback) {
    var config = getConfig();
    http.get("/video_info?source=youtube&video_id=" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getVideoDetailById(id, callback) {
    var config = getConfig();
    http.get("/video/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function getCountVideo(callback) {
    var config = getConfig();
    http.get("/video/admin/get-count", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function getListVideo(params, callback) {
    var config = getConfig();
    var url = `/admin/videos?search=${params.search}&page=${params.page}&size=${params.size}`;
    if (params.mapel) {
        url += `&mapel=${params.mapel}`;
    }

    if (params.bab) {
        url += `&bab=${params.bab}`;
    }

    if (params.title) {
        url += `&title=${params.title}`;
    }

    if (params.grade) {
        url += `&grade=${params.grade}`;
    }

    if (params.subject) {
        url += `&subject=${params.subject}`;
    }

    if (params.kurikulum) {
        url += `&kurikulum=${params.kurikulum}`;
    }

    if (params.status) {
        url += `&status=${params.status}`;
    }

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListVideoByModuleId(moduleId, callback) {
    var config = getConfig();
    http.get("/videos?module_id=" + moduleId, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListVideoLiveStreamByModuleId(moduleId, callback) {
    var config = getConfig();
    http.get("/streamings?module_id=" + moduleId, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteVideo(id, callback) {
    var config = getConfig();
    http.delete("/video/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function addVideo(dataBody, callback) {
    var config = getConfig();

    http.post("/video", dataBody, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addVideoLiveStreaming(dataBody, callback) {
    var config = getConfig();

    http.post("/streaming", dataBody, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editVideo(id, dataBody, callback) {
    var config = getConfig();
    http.put("/video/" + id, dataBody, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListVideoByBab(id, grade, callback) {
    var config = getConfig();
    http.get("/video/list/nourut?bab_id=" + id + "&grade=" + grade, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function changeSequence(dataBody, callback) {
    var config = getConfig();
    http.put("/video/change/nourut", dataBody, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editVideoLiveStreaming(id, dataBody, callback) {
    var config = getConfig();
    http.put("/streaming/" + id, dataBody, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteVideoStreaming(id, callback) {
    var config = getConfig();
    http.delete("/streaming/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function setPublishing(id, dataBody, callback) {
    var config = getConfig();
    http.put("/streaming/" + id + "/publish", dataBody, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function duplicateVideo(video, callback) {
    var config = getConfig();
    http.post(`/video/${video.id}/duplicate`, video, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    getVideoDetail,
    getListVideo,
    getCountVideo,
    deleteVideo,
    addVideo,
    getVideoDetailById,
    editVideo,
    changeSequence,
    getListVideoByModuleId,
    getListVideoByBab,
    getListVideoLiveStreamByModuleId,
    addVideoLiveStreaming,
    deleteVideoStreaming,
    editVideoLiveStreaming,
    setPublishing,
    duplicateVideo,
};



// WEBPACK FOOTER //
// ./src/modules/vd_pembelajaran/services/video.js